<template>
  <div class="text-center">
    <aha-icon name="no-presentation" maintain-color />
    <div v-if="!shared" class="text-base font-bold">
      {{ $i18nPresenter.t('No presentations here yet') }}
    </div>
    <div v-else class="text-base font-bold">
      {{ $i18nPresenter.t('No shared presentations here yet') }}
    </div>
    <div class="mt-2 text-base-80">
      <p v-if="shared">
        {{ $i18nPresenter.t('When someone shares their presentation with you, it will show up here.') }}
      </p>
      <p v-else>
        {{ $i18nPresenter.t('You can create and import a presentation here.') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shared: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
